import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { apiEndpointURL } from '@app/core/constants/endpoints-url';
import { Utilities } from '@app/core/utils/utilities';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EasyLoadService {
  httpClient = inject(HttpClient);
  util = inject(Utilities);

  getReportDetails(institutionId: any, pageNumber: any, entityType: string, sortBy?: any, sortOrder?: any, appliedFilter?: any) {
    const url = [apiEndpointURL.easyLoadReportListEndpoint, institutionId].join('/');
    let params = new HttpParams().set('pageNumber', pageNumber).set('pageSize', this.util.recordsPerPage()).set('entityType', entityType);
    if (sortBy)
      params = params.set('sortBy', sortBy);
    if (sortOrder)
      params = params.set('sortOrder', sortOrder);
    if (appliedFilter)
      Object.keys(appliedFilter).forEach((data) => {
        params = params.set(data, appliedFilter[data])
      });
    return this.httpClient.get(url, { params });
  }

  initDownload(institutionId: any, userId: any, entityType: string): Observable<any> {
    const insitDownloadUrl = [apiEndpointURL.easyLoadInitDownloadEndpoint, institutionId].join('/');
    return this.httpClient.post(insitDownloadUrl, { "createdBy": userId, entityType });
  }

  getDownloadReportPreSignedUrl(fileName: string, entityType: string, reportType?: string) {
    fileName = (reportType === 'report_popup' ? 'Reports_' : 'Generate_') + fileName;
    const url = [apiEndpointURL.easyLoadReportDownloadEndpoint, fileName].join('/');
    const jsonBodyContent = { updatedBy: Number(this.util.getStoredUserDetails().userId), entityType };
    return this.httpClient.post(url, jsonBodyContent);
  }
}
